import { useEffect } from "react";

function upsert(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Lightweight SEO head manager (React 19 friendly, no helmet dependency). */
export default function Seo({ title, description, path = "", jsonLd, noindex = false }) {
  useEffect(() => {
    const base = "https://www.measuretheroof.com";
    const url = base + path;
    if (title) document.title = title;
    upsert("name", "description", description);
    upsert("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", url);
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
  }, [title, description, path, jsonLd, noindex]);

  return null;
}
